const pendingStatuses = ['pending-review', 'pending', 'processing', 'submitted', 'in-review']

export {
    pendingStatuses
}
